import React from 'react';
var AKTagGroup = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.tag' */
  '@atlaskit/tag-group');
});
var TagGroup = function TagGroup(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(AKTagGroup, null, children);
};
export default TagGroup;
export var TagGroupFn = function TagGroupFn(_ref2) {
  var children = _ref2.children,
    dispatch = _ref2.dispatch,
    Components = _ref2.Components,
    render = _ref2.render,
    renderChildren = _ref2.renderChildren;
  return /*#__PURE__*/React.createElement(TagGroup, null, renderChildren({
    children: children,
    dispatch: dispatch,
    Components: Components,
    render: render
  }));
};